import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	CONNECT_SELECT_CF_TYPE,
	ISSUE_FIELD_SINGLE_SELECT_CF_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	toLegacyConnectOption,
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

const transformAggConnectSingleSelectToLegacyFieldOld: FieldTransformer = (node) => {
	let value = null;

	if (node.fieldOption != null) {
		value = {
			id: parseInt(node.fieldOption?.optionId, 10),
			value: node.fieldOption?.value,
		};
	}

	return {
		...transformAggNodeToLegacyField(node),
		value,
		allowedValues: transformAggConnection(
			node.connectSingleSelectFieldOptions,
			toLegacyConnectOption,
		),
		schema: {
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			custom: node.type,
			type: ISSUE_FIELD_SINGLE_SELECT_CF_TYPE,
		},
	};
};

const transformAggConnectSingleSelectToLegacyFieldNew: FieldTransformer = (node) => {
	let value = null;

	if (node.fieldOption != null) {
		value = {
			id: node.fieldOption.optionId,
			value: node.fieldOption.value ?? null,
			ari: node.fieldOption.id,
		};
	}

	return {
		...transformAggNodeToLegacyField(node),
		value,
		allowedValues: [],
		schema: {
			configuration: null,
			items: null,
			renderer: PLAIN_TEXT,
			system: null,
			custom: node.type,
			type: CONNECT_SELECT_CF_TYPE,
		},
	};
};

export const transformAggConnectSingleSelectToLegacyField: FieldTransformer = (node) => {
	return fg('dfo_remove_connect_single_select_field_options_agg')
		? transformAggConnectSingleSelectToLegacyFieldNew(node)
		: transformAggConnectSingleSelectToLegacyFieldOld(node);
};
